import { createFileRoute } from '@tanstack/react-router';

import {
  auctionListParams,
  auctionListQueryOptions,
  auctionListSearchSchema,
  AuctionsPage,
} from '@/features/auctions';

export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions/')({
  staticData: { tours: ['auctions.list'] },
  validateSearch: auctionListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...auctionListQueryOptions(params.storeId, auctionListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Tab and page changes on the list itself must not wait for the fetch; the page shows the
    // previous rows meanwhile.
    if (cause !== 'stay') await prefetch;
  },
  component: AuctionsPage,
});
